var $selected_layer = null;

// Stand room editor
if (($("body").hasClass("stands-general") || $("body").hasClass("stand-detail")) && 
    $(".layer-editor").length == 1) {
    var $layer_editor = $(".layer-editor");

    var layer_selector = $layer_editor.data("layer-selector");

    $("#btn_layout_edit").on("click", function () {
        $("#btn_layout_edit").prop('disabled', true);
        $("#btn_layout_save").prop('disabled', false);
        $(".wrap-editing input").prop('disabled', false);
    
        $selected_layer = $(layer_selector).first();
        $selected_layer.addClass("active");
        populate_input_data($selected_layer);
        
        $(layer_selector).addClass("editing").off("click").on("click", function (e) {
            e.preventDefault();
            $(layer_selector).removeClass("active");
            $selected_layer = $(this).addClass("active");
    
            populate_input_data($selected_layer);
        });
    
        $(".wrap-editing").show();
    });
    
    $("#btn_layout_save").on("click", function () {
        $("#btn_layout_edit").prop('disabled', false);
        $("#btn_layout_save").prop('disabled', true);
        $(".wrap-editing input").prop('disabled', true);
    
        $(layer_selector).removeClass("editing").removeClass("active").off("click");
    
        $(".wrap-editing").hide();
    
        var save_data = [];

        $(layer_selector).each(function () {
            var $selected = $(this);

            save_data.push({
                "id": $selected.data("id"),
                "top": $selected[0].style.top,
                "left": $selected[0].style.left,
                "width": $selected[0].style.width,
                "height": $selected[0].style.height
            });
        });

        $.ajax({
            method: "GET",
            url: $layer_editor.data("url"),
            data: { data: JSON.stringify(save_data) }
        }).done(function(data) {
            // console.log("success!!!");
            document.location.reload();
        }).fail(function() {
            console.log(save_data);
            alert("Error al guardar la info de posicionamiento!!!\n Consulta la consola de Chrome DevTools para ver la informacion que no se ha guardado.");
        });
    });

    function populate_input_data($selected) {
        $(".label-layer-id").text($selected.data("id"));
        $("#layer_top").val(parseFloat($selected[0].style.top));
        $("#layer_left").val(parseFloat($selected[0].style.left));
        $("#layer_width").val(parseFloat($selected[0].style.width));
        $("#layer_height").val(parseFloat($selected[0].style.height));
    
        $(".wrap-editing input").off("input").on("input", function() {
            $selected[0].style.top = $("#layer_top").val() + "%";
            $selected[0].style.left = $("#layer_left").val() + "%";
            $selected[0].style.width = $("#layer_width").val() + "%";
            $selected[0].style.height = $("#layer_height").val() + "%";
        });
    }
}


/*
// Stand search
window.stand_search_on_select = function (data) {
    document.location = $(".stand-" + data.data).attr("href");
};
*/
